import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import { CommonConsult } from "../common-consult";
import { Button } from "../../components/Button";

export const PrivateCloudBanner = () => {
  const { t } = useTranslation();
  return (
    <section>
      <div className="private-cloud-banner-warp">
        <div className="private-cloud-banner">
          <div className="banner-content">
            <h1 className="banner-title">
              {t("solution.privateCloud.banner.title")}
            </h1>
            <div className="banner-subtitle">
              {t("solution.privateCloud.banner.subtitle")}
            </div>
            <div style={{ width: "200px" }}>
              <CommonConsult
                aside={
                  <Button style={{ margin: 0 }}>
                    {t("common.button.consult")}
                  </Button>
                }
              />
            </div>
          </div>
          <div className="banner-img">
            <img
              src={`//files.authing.co/authing-website/private-cloud-banner-bg-tiny.png`}
              alt="身份云私有化部署"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
